<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells>
        <app-button @click.native="onShowModal(undefined)">Add item</app-button>
        <app-input
          @input.native="onItemSearch"
          v-model="filter_search"
          class="input--200"
          type="search"
          placeholder="Search by name"
          name="search"
        />
        <app-select
          @input="onChangeFilter"
          v-model="filter_group"
          :options="filter_group_options"
          :reduce="item => item.id"
          placeholder="Transaction group"
          class="select--200"
        />
        <app-filters
          v-model="filter_type"
          :filters="filter_type_options"
          name="filterType"
          @change="onChangeFilter"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #h__name_expense><div class="table-default__left">Expense name</div></template>
        <template #h__name_revenue><div class="table-default__left">Revenue name</div></template>
        <template #count="{ index }">{{ index }}</template>
        <template #name="{ row }"><div class="table-default__left">{{ row.name }}</div></template>
        <template #name_expense="{ row }"><div class="table-default__left">{{ row.name_expense || '-' }}</div></template>
        <template #name_revenue="{ row }"><div class="table-default__left">{{ row.name_revenue || '-' }}</div></template>
        <template #slug="{ row }">{{ row.slug || '-' }}</template>
        <template #type="{ row }">
          <div class="table-default__controls">
            <span class="status-tag" :style="{ 'backgroundColor': row.expense ? '#77b017' : '#e85c20' }">Expense</span>
            <span class="status-tag" :style="{ 'backgroundColor': row.revenue ? '#77b017' : '#e85c20' }">Revenue</span>
          </div>
        </template>
        <template #group="{ row }">{{ row.group?.name || '-' }}</template>
        <template #controls="{ row }">
          <div class="table-default__controls">
            <button @click="onShowModal(row)" type="button">
              <img src="@/assets/img/edit-table-icon.svg" alt="Edit">
            </button>
            <button @click="onShowDeleteModal(row.id)" type="button">
              <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
    <modal
      name="edit-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('edit-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">{{ !item_to_update ? 'Add' : 'Update' }} item</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Name" label-for="name" required>
              <app-input
                v-model="form.name"
                placeholder="Name"
                id="name"
                name="name"
                :error="$v.form.name.$error"
              />
              <template #error>
                <div v-if="$v.form.name.$dirty && !$v.form.name.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Expense name" label-for="expense-name" required>
              <app-input
                v-model="form.name_expense"
                placeholder="Expense name"
                id="expense-name"
                name="expense-name"
                :error="$v.form.name_expense.$error"
              />
              <template #error>
                <div v-if="$v.form.name_expense.$dirty && !$v.form.name_expense.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Revenue name" label-for="revenue-name" required>
              <app-input
                v-model="form.name_revenue"
                placeholder="Revenue name"
                id="revenue-name"
                name="revenue-name"
                :error="$v.form.name_revenue.$error"
              />
              <template #error>
                <div v-if="$v.form.name_revenue.$dirty && !$v.form.name_revenue.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group>
              <app-cells :indent="false">
                <app-checkbox
                  v-model="form.expense"
                  label="Expense"
                />
                <app-checkbox
                  v-model="form.revenue"
                  label="Revenue"
                />
              </app-cells>
            </app-form-group>
            <app-form-group label="Sort" label-for="sort">
              <app-input
                v-model="form.sort"
                placeholder="Sort"
                id="sort"
                name="sort"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="submit" :disabled="$v.form.$error">{{ !item_to_update ? 'Add' : 'Save' }}</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="delete-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete item
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this item?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteItem" ref="deleteItem">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  deleteFinanceTransactionsItem,
  getFinanceTransactionsItemGroupsList,
  getFinanceTransactionsItemsList,
  patchFinanceTransactionsItem,
  postFinanceTransactionsItem,
} from '@/http'
import { required } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'

export default {
  name: 'FinanceDictionariesTransactionItems',
  data() {
    return {
      page_loaded: false,
      item_to_delete: null,
      item_to_update: null,
      table_preloader: false,
      filter_search: '',
      filter_group: null,
      filter_group_options: [],
      filter_type: '',
      filter_type_options: [
        { value: '', label: 'All' },
        { value: 'expense', label: 'Expense' },
        { value: 'revenue', label: 'Revenue' },
      ],
      form: {},
      table: {
        items: [],
        columns: [
          'count',
          'name',
          'name_expense',
          'name_revenue',
          'slug',
          'type',
          'group',
          'sort',
          'controls'
        ],
        options: {
          headings: {
            'count': '#',
            'name': 'Name',
            'name_expense': 'Expense name',
            'name_revenue': 'Revenue name',
            'slug': 'Slug',
            'type': 'Expense / Revenue',
            'group': 'Group',
            'sort': 'Sort',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  validations: {
    form: {
      name: { required },
      name_expense: { required },
      name_revenue: { required },
    }
  },
  created() {
    this.fetchItems()
    getFinanceTransactionsItemGroupsList().then(response => { this.filter_group_options = response.data })
  },
  methods: {
    fetchItems() {
      this.table_preloader = true
      getFinanceTransactionsItemsList({
        page: this.pagination.page,
        page_size: 20,
        search: this.filter_search,
        group: this.filter_group,
        expense: this.filter_type === 'expense' || '',
        revenue: this.filter_type === 'revenue' || '',
      })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.page_loaded = true
          this.table_preloader = false
        })
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      const data = {
        name: this.form.name,
        name_expense: this.form.name_expense,
        name_revenue: this.form.name_revenue,
        expense: this.form.expense,
        revenue: this.form.revenue,
        sort: this.form.sort,
      }
      if (this.item_to_update) {
        patchFinanceTransactionsItem(this.item_to_update, data)
          .then(() => {
            this.fetchItems()
            this.$notify({
              type: 'success',
              title: 'Item updated',
            })
            this.$modal.hide('edit-modal')
          })
          .catch(() => {
            this.$refs.submit.preload = false
          })
      } else {
        postFinanceTransactionsItem(this.form)
          .then(() => {
            this.fetchItems()
            this.$notify({
              type: 'success',
              title: 'Item created',
            })
            this.$modal.hide('edit-modal')
          })
          .catch(() => {
            this.$refs.submit.preload = false
          })
      }
    },
    onDeleteItem() {
      this.$refs.deleteItem.preload = true
      deleteFinanceTransactionsItem(this.item_to_delete)
        .then(() => {
          this.fetchItems()
          this.$notify({
            type: 'success',
            title: 'Item deleted',
          })
          this.$modal.hide('delete-modal')
        })
        .catch(() => {
          this.$refs.deleteItem.preload = false
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    onShowModal(data = { expense: false, revenue: false }) {
      this.item_to_update = data.id || null
      this.form = data
      this.$v.form.$reset()
      this.$modal.show('edit-modal')
    },
    onShowDeleteModal(item_id) {
      this.item_to_delete = item_id
      this.$modal.show('delete-modal')
    },
    onChangeFilter() {
      this.filter_search = ''
      this.pagination.page = 1
      this.fetchItems()
    },
    onItemSearch() {
      this.searchItem(this)
    },
    searchItem: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
  }
}
</script>
